export default "assets/images/icons/slider-arrow2-345499bb.svg";